import { EnvSchema, type Env } from "@fluentry/domain";
import { devDefaults } from "./defaults";
import * as v from "valibot";

export function parseEnv(env: Record<string, any>): Env {
  // マージ戦略: デフォルト値 < process.env < Cloudflare env
  const merged: Record<string, any> = {
    ...devDefaults,
    ...(typeof process !== "undefined" ? process.env : {}),
    ...env,
  };

  // Compatibility: prefer CF_AIG_* then fallback to AI_GATEWAY_*
  if (!merged.AI_GATEWAY_BASE_URL && merged.CF_AIG_BASE_URL) {
    merged.AI_GATEWAY_BASE_URL = merged.CF_AIG_BASE_URL;
  }
  if (!merged.AI_GATEWAY_API_KEY && merged.CF_AIG_API_KEY) {
    merged.AI_GATEWAY_API_KEY = merged.CF_AIG_API_KEY;
  }
  if (!merged.AI_GATEWAY_PRIMARY_MODEL && merged.CF_AIG_PRIMARY_MODEL) {
    merged.AI_GATEWAY_PRIMARY_MODEL = merged.CF_AIG_PRIMARY_MODEL;
  }
  if (!merged.AI_GATEWAY_FALLBACK_MODEL && merged.CF_AIG_FALLBACK_MODEL) {
    merged.AI_GATEWAY_FALLBACK_MODEL = merged.CF_AIG_FALLBACK_MODEL;
  }

  const result = v.safeParse(EnvSchema, merged);

  if (!result.success) {
    console.warn("Invalid environment variables:", v.flatten(result.issues));
    // 開発中はエラーを投げずに、可能な限り動作させる
    return merged as Env;
  }

  return result.output;
}

// ヘルパー: 特定のキーを取得
export function getEnv<K extends keyof Env>(env: Record<string, any>, key: K): Env[K] {
  const parsed = parseEnv(env);
  return parsed[key];
}
